module.exports = __webpack_public_path__ + "img/pizza_chorizo_done.b2c31254.jpg";